import { createFileRoute } from "@tanstack/react-router";

import FeedbackPage from "@/admin/reports/feedback/page";

export const Route = createFileRoute("/app/$storeId/reports/feedback")({
    component: RouteComponent,
});

function RouteComponent() {
    return <FeedbackPage />;
}
